import { Link } from "react-router-dom";
import type { Actor } from "@/types/media";

interface ActorCardProps {
  actor: Actor;
  isFav: boolean;
  onToggleFav: (id: string) => void;
}

export default function ActorCard({ actor, isFav, onToggleFav }: ActorCardProps) {
  return (
    <div className="group bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 transition-colors overflow-hidden">
      <Link to={`/actor/${actor.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-square overflow-hidden bg-background-200">
          <img
            src={actor.avatar}
            alt={`${actor.name} 头像`}
            title={`${actor.name} 演员资料`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-3">
          <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
            {actor.name}
          </h3>
          <p className="mt-1 text-xs text-foreground-500 truncate">
            {actor.gender} · {actor.birthplace}
          </p>
        </div>
      </Link>
      <div className="px-3 pb-3 flex items-center justify-between gap-2">
        <div className="flex flex-wrap gap-1.5 min-w-0">
          {actor.tags.slice(0, 2).map((t) => (
            <span
              key={t}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs whitespace-nowrap"
            >
              {t}
            </span>
          ))}
        </div>
        <button
          type="button"
          aria-label={isFav ? "取消收藏" : "收藏演员"}
          onClick={() => onToggleFav(actor.id)}
          className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
            isFav
              ? "bg-accent-500 text-secondary-950"
              : "bg-background-100 text-foreground-500 hover:text-accent-600"
          }`}
        >
          <i className={isFav ? "ri-heart-3-fill" : "ri-heart-3-line"}></i>
        </button>
      </div>
    </div>
  );
}